import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import MicrophonePlugin from "wavesurfer.js/dist/plugin/wavesurfer.microphone.min.js";
import css from "./lesson.module.css";

const AudioRecorderPopup = ({
  isOpen,
  onClose,
  questionId,
  onSaveRecording,
}) => {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    if (isOpen && waveformRef.current) {
      wavesurferRef.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "#7509FF",
        progressColor: "#6d6d6d",
        cursorColor: "#FF0000",
        barWidth: 2,
        barHeight: 1,
        height: 100,
        plugins: [
          MicrophonePlugin.create({
            bufferSize: 4096,
            numberOfInputChannels: 1,
            numberOfOutputChannels: 1,
            constraints: {
              audio: true,
            },
          }),
        ],
      });

      wavesurferRef.current.microphone.on("deviceReady", (stream) => {});

      wavesurferRef.current.microphone.on("deviceError", (error) => {
        console.error("Microphone error:", error);
      });
    }

    return () => {
      if (wavesurferRef.current) {
        wavesurferRef.current.microphone.destroy();
        wavesurferRef.current.destroy();
      }
    };
  }, [isOpen]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      const audioChunks = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunks.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/ogg; codecs=opus" });
        onSaveRecording(audioBlob);
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);

      if (wavesurferRef.current) {
        wavesurferRef.current.microphone.start();
      }
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }

    if (wavesurferRef.current) {
      wavesurferRef.current.microphone.stop();
      wavesurferRef.current.microphone.destroy();
    }

    if (mediaRecorderRef.current?.stream) {
      mediaRecorderRef.current.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }

    setIsRecording(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };
  useEffect(() => {
    if (isOpen === true) {
      startRecording();
    }
  }, [isOpen]);
  return isOpen ? (
    <div className={css.popup}>
      <div className={css.popupContent}>
        <div id="waveform" ref={waveformRef}></div>
        <div className={css.wrapTwoButStop}>
          <button
            onClick={stopRecording}
            disabled={!isRecording}
            className={css.nextButton}
          >
            Stop
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default AudioRecorderPopup;
